import { type ErrorContexts, type WithContext } from './WithContext';

interface ContextErrorOptions {
    context: ErrorContexts;
    cause?: unknown;
}

export class ContextError extends Error implements WithContext {
    public readonly context: ErrorContexts;

    constructor(message: string, options: ContextErrorOptions) {
        const { context, cause } = options;
        // FIXME: Upgrade compilerOptions.lib to ES2022 to use `cause` in Error constructor
        // https://github.com/lingoda/lingoda/pull/26251
        // @ts-expect-error - TypeScript does not support passing cause in Error yet
        super(message, { cause });
        this.name = 'ContextError';
        this.context = context;
    }
}
